<template>
  <div class="receiving-orders">
    <CustomTitle title="业务接单统计" :month="ym" style="margin-bottom:22px" />
    <template v-if="bbb && bbb.data && bbb.data.length">
      <ReceivingOrderItem
        ref="ReceivingOrderItem"
        v-for="(item, index) in bbb.data.slice(0, 3)"
        :key="index"
        :item="item"
        :index="index + 1"
        :maxNumber="bbb.data[0].value"
      />
      <div class="scroll-chart">
        <vue-seamless-scroll
          :data="bbb.data"
          class="warp"
          :class-option="classOption"
          :limitMoveNum="8"
        >
          <ReceivingOrderItem
            v-for="(item, index) in bbb.data.slice(3, bbb.data.length)"
            :key="index"
            :item="item"
            :index="index + 4"
            :maxNumber="bbb.data[0].value"
          />
        </vue-seamless-scroll>
        <!-- <pre>{{bbb.data[0]}}</pre> -->
      </div>
    </template>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import ReceivingOrderItem from '@/components/ReceivingOrderItem'
import vueSeamlessScroll from 'vue-seamless-scroll'
import config from '@/js/config'
import moment from 'moment'
export default {
  name: 'ReceivingOrders',
  data () {
    return {
      timer: null, // 用于20分钟请求一次接口
      requestFunTimer: null, // 每秒钟执行一下判断时间方法
      switchTimer: null, // 每两分钟切换一下月和周的数据
      bbb: {},
      // 用于临时存储数据
      monthData: {}, // 月
      weekData: {}, // 周
      dataType: 'month', // 目前展示的数据的类型
      daydata: {},
      daypridata: {},
      weekdata: {},
      weekpridata: {},
      monthpridata: {},
      viewkind: 0,
      headtetile: '业务接单统计',
      compid: -1,
      dept: '',
      ym: new Date().getMonth() + 1 + ' 月',
      componentHeight: 0,
      classOption: {
        singleHeight: 30
      },
      dst: '',
      ded: '',
      nowDate: '', // 当前是多少号
      updateflag:0,
      datakind:1,
      logtime:'',
      requestUrl:'',

    }
  },
  methods: {
    timerfun () {
      this.timer = setInterval(() => {
        // if (this.daydata.lenght === 0) {
        //   this.getCliorder(1)
        // }
        // this.getMonthAndWeekData()
        // if(this.dataType == 'month')
        // { 
        //     this.getMonthAndWeekData(3);
        //     this.bbb = JSON.parse(JSON.stringify(this.weekData))
        //     this.dataType = 'week'
        //     this.ym = '第 ' + this.getYearWeek(new Date()) + ' 周'    
        //     this.monthData={}         
        // }
        // else 
        // {
           

        // }
          
        this.updateflag=1;
        // console.log(this.updateflag);
      },config.refreshTime.receivingOrders) //40*1000)//
    },
    // 计算本年的周数
    getYearWeek (endDate) {
      // 本年的第一天
      var beginDate = new Date(endDate.getFullYear(), 0, 1)
      // 星期从0-6,0代表星期天，6代表星期六
      var endWeek = endDate.getDay()
      if (endWeek === 0) endWeek = 7
      var beginWeek = beginDate.getDay()
      if (beginWeek === 0) beginWeek = 7
      // 计算两个日期的天数差
      var millisDiff = endDate.getTime() - beginDate.getTime()
      var dayDiff = Math.floor(
        (millisDiff + (beginWeek - endWeek) * (24 * 60 * 60 * 1000)) / 86400000
      )
      return Math.ceil(dayDiff / 7) + 1
    },
    // 获取数据
    async getCliorder (datekind) {
      // this.compid = this.$cookies.get('bsmcompid')
      // this.dept = this.$cookies.get('bsmdept')
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')

      
      await this.axios({
        method: 'get',
        // params: {
        //   compid: this.compid,
        //   datekind:0,
        //   dst: this.dst,
        //   ded: this.ded
        // },
        url: this.requestUrl+'/admin.php/Bigsreen/orderandshipfun?datekind='+datekind+'&compid='+this.compid+'&dst='+this.dst+'&ded='+this.ded
      })
        .then(Response => {
          var clio = JSON.parse(Response.data)
          var ndata = []
          var sumdata = []
          var sumpri = 0
          var sumpcs = 0
          var sumpg = 0
          // console.log(clio);
          // console.log("orderandshipfun="+Response.data)

          clio.forEach((item, i) => {
            var pri = 0
            if (item['sumpricermb'] != null) {
              pri = item['sumpricermb'] / 1
              pri = pri.toFixed(1)
            }
            var addpri = ''
            if (this.dept === 'Sales') {
              addpri = ' ' + pri + '万元'
            }
            var da = {
              name: item['Proset'] / 1 + '件' + addpri,
              pg: item['Proset'] / 1,
              value: item['pg'] / 1,
              client: item['Client']
            }
            ndata.push(da)
            var dasum = {
              name: item['Client'] + '共:' + item['Proset'] + '件',
              value: pri
            }
            sumdata.push(dasum)
            sumpri += pri / 1
            sumpcs += item['Proset'] / 1
            sumpg += item['pg'] / 1
          })
          var cc = {
            data: ndata,
            unit: '件',
            rowNum: 12,
            headerBGC: '#1981f6'
          }
          var ee = {
            data: sumdata,
            unit: '万元',
            rowNum: 12,
            headerBGC: '#1981f6'
          }
          // cc.data = cc.data.length > 1 ? cc.data.sort((a, b) => b.value - a.value) : cc.data
          // this.bbb = cc
          if (datekind === 1) {
            this.monthData = cc
            this.monthpridata = ee
            this.$eventBus.$emit('SalesumMMOrder', [sumpcs, sumpri, sumpg])
          } else if (datekind === 0) {
            this.daydata = cc
            this.daypridata = ee
          } else if (datekind === 3) {
            this.weekData = cc
            this.monthpridata = ee
          }
        })
        .catch(function (error) {
          console.log(error+"  ReceivingOrders")
        })
    },
    // 获取月和周的数据 先获取月随后获取周
    async getMonthAndWeekData (kind) {
      await this.getCliorder(kind)
      this.bbb = JSON.parse(JSON.stringify(this.monthData))
      // console.log(this.bbb)
      this.$nextTick(() => {
        // 获取元素的高度
        const componentHeight = this.$refs['ReceivingOrderItem'][0].$el
          .offsetHeight
        this.classOption = {
          singleHeight: componentHeight
        }
      })
      // await this.getCliorder(3)
    },
    // 每秒执行方法判断逻辑时间
    requestFun () {
      const momentTime = moment()
           // 当前小时
      let hour = momentTime.hour()

      if(this.logtime=='' || (hour==7 && momentTime.minute()==10 && momentTime.second()==20))
      {
          this.logtime=window.localStorage.getItem('bsmlogdate')
          this.logtime = this.logtime.replace(/-/g, '/');          
      }
      let tt=new Date(this.logtime);
      //console.log(this.logtime+"tt="+tt +' (timeDate<tt)='+(timeDate<tt))
      if(momentTime._d<tt)
      { 
        momentTime._d=tt;            
      }

      // console.log(momentTime._d);
      
      // 当前日
      let date = momentTime.date()
      // console.log("date="+date);

      this.nowDate = date
      // 如果日期大于等于4 则dst ded传当天，否则往前推一个月
      this.dst =
        date >= 4
          ? momentTime.format('YYYY-MM-DD')
          : momentTime.subtract(1, 'months').format('YYYY-MM-DD')

      this.ded = this.dst
      // 如果当前小时在8-21之间，
      if (hour >= 8 && hour < 21) {
        // 先看定时器是否是开始的，没开始的时候设置定时器
        if (!this.timer) {
          // 开启请求任务
          this.timerfun()
        }
      } else {
        // 如果定时器是开始的，则清空定时器
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    }
  },
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.requestFun()
    /**
     * nowDate（几号），如果nowDate >= 4
     * 往前推一个月赋值给 des 和 ded，否则 des 和 ded 赋值当天日期
     * ym 根据 nowDate 判断赋值，标题显示 上月 或 本月
     * 调用 datekind=1&des&ded 接口
     * 调用 datekind=3&des&ded 接口
     * 两分钟之后进行数据切换
     */
    if (this.nowDate >= 4) {
      this.ym = new Date().getMonth() + 1 + ' 月'
    } else {
      this.ym =
        moment()
          .subtract(1, 'months')
          .month() +
        1 +
        ' 月'
    }
    // 无论如何，页面加载都会先执行加载数据方法
    this.getMonthAndWeekData(1)
    // 获取时间
    this.requestFunTimer = setInterval(() => {
      this.requestFun()
    }, 1000)

    this.switchTimer = setInterval(() => {
      // 如果当前展示的是月数据，则切换到周
      // console.log("this.updateflag="+ this.updateflag)
      if (this.dataType === 'month') {
        //var kk=JSON.stringify(this.weekData)=='{}'
        var ii=typeof this.weekData.unit=='undefined'
        // console.log("  ii="+ ii)
        if(ii )
        {
           this.getMonthAndWeekData(3);
        }
        else
        {           
            this.bbb = JSON.parse(JSON.stringify(this.weekData))
            this.dataType = 'week'
            this.ym = '第 ' + this.getYearWeek(new Date()) + ' 周'
        }
        if(this.updateflag==1)
        {
           this.getMonthAndWeekData(3);
        }

      } else {

        this.bbb = JSON.parse(JSON.stringify(this.monthData))
        this.dataType = 'month'
        if (this.nowDate >= 4) {
          this.ym = new Date().getMonth() + 1 + ' 月'
        } else {
          this.ym =
            moment()
              .subtract(1, 'months')
              .month() +
            1 +
            ' 月'
        }
        if(this.updateflag==1)
        {
           this.getMonthAndWeekData(1);
           this.updateflag=0
        }
      }
    }, 120 * 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.requestFunTimer) {
      clearInterval(this.requestFunTimer)
    }
    if (this.switchTimer) {
      clearInterval(this.switchTimer)
    }
  },
  components: {
    CustomTitle,
    ReceivingOrderItem,
    vueSeamlessScroll
  },
  watch: {},
  mounted () {}
}
</script>

<style scoped lang="less">
.receiving-orders {
  display: flex;
  flex-direction: column;
  height: 100%;

  .scroll-chart {
    flex: 1;
    height: 0;
    min-height: 100px;
    overflow: hidden;
    .warp {
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/ReceivingOrders.vue